import '@babel/polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import AffiliationsBlock from '../js/components/AffiliationsBlock/AffiliationsBlock.js';

if (window.homePageVar) {
    ReactDOM.render(
        <AffiliationsBlock
            blockTitle={'Skye Learning<sup class="sup-small3" aria-hidden="true">&reg;</sup> Affiliations'}
            blockTitleClass={'ubuntu--light h2'}
            blockTitlelevel={'h3'}
            blockTextContent={'Skye Learning<sup class="sup-small3" aria-hidden="true">&reg;</sup>’s parent company, ' +
                'MindEdge Learning, has well-established relationships with the ' +
                'following professional development credit organizations. ' +
                'After taking a course, you will be granted a Certificate of ' +
                'Achievement with all necessary information for claiming your ' +
                'earned credits.'
            }
            textContentClassName={'affiliations-block__text_content'}
            additionalContent={'As an <abbr title="I A C E T"><span aria-hidden="true">IACET</span></abbr> Accredited Provider, MindEdge offers <abbr title="I A C E T, C E Us"><span aria-hidden="true">IACET CEUs</span></abbr> for its learning events that comply with the <abbr title="A N S I / I A C E T"><span aria-hidden="true">ANSI/IACET</span></abbr> Continuing Education and Training Standard.'}
        />,
        document.getElementById('affiliationsBlock')
    );
} else {
    ReactDOM.render(
        <AffiliationsBlock
            blockTitle={'Skye Learning<sup class="sup-small3" aria-hidden="true">&reg;</sup> Affiliations'}
            blockTitleClass={'ubuntu--light h2'}
            blockTitlelevel={'h3'}
            blockTextContent={''}
            textContentClassName={'about-affiliations__content text-content'}
            
        />,
        document.getElementById('affiliationsBlock')
    );
}
